<template>
  <div class="home-header">
    <div :class="{ 'h5-header-box': true, 'change-header': (changeHeader || $route.path === '/faq') }">
      <div class="h5-header-content">
        <div class="logo-in-header">
          <router-link to="/"
            ><img src="/static/img/home/header_logo.png" alt=""
          /></router-link>
        </div>
        <div class="header-nav">
          <div class="menu-phone pull-right">
            <div
              class="fold-navigation"
              data-toggle="dropdown"
              role="button"
              aria-label="button"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img src="/static/img/home/h5_header_btn.png" alt="" />
              <!-- <span></span>
              <span></span>
              <span></span> -->
            </div>
            <ul class="dropdown-menu">
              <li class="border-bottom">
                <router-link to="/">{{ $t("index") }}</router-link>
              </li>
              <li class="border-bottom">
                <router-link to="/download">{{ $t("download") }}</router-link>
              </li>
              <li class="border-bottom nickname-li" v-if="hasToken">
                <router-link to="/dashboard" class="nickname">
                  {{ nickName }}
                </router-link>
              </li>
              <li class="border-bottom" v-on:click.stop>
                <choose-lang-in-m></choose-lang-in-m>
              </li>
              <li class="border-bottom" v-if="!hasToken">
                <router-link to="/login">{{ $t("signIn") }}</router-link>
              </li>
              <li v-if="!hasToken">
                <router-link to="/register">
                  {{ $t("signUp") }}
                </router-link>
              </li>
              <li v-if="hasToken">
                <a href="javascript:void(0)" @click="signOut">
                  {{ $t("signOut") }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- <logo-in-header class="pull-left" :color="customLogoColor"></logo-in-header> -->
  </div>
</template>

<script>
import LogoInHeader from "../../logoInHeader/LogoInHeader.vue";
import ChooseLangInM from "../../chooselang/ChooseLangInM.vue";
import locales from "./lang";
import { mapState } from "vuex";
import activity from "../../../config/activity";

export default {
  name: "main-header-phone",
  components: { LogoInHeader, ChooseLangInM },
  locales,
  computed: {
    ...mapState({
      user: (state) => state.user,
      nickName: (state) => state.user["nickname"],
      hasToken: (state) => state.hasToken,
      mediaType: (state) => state.mediaType,
      specialHeader: (state) => state.header.specialHeader,
      isdownload: (state) => state.header.isdownload,
      isHeader: "isHeader",
    }),
    backendLink() {
      return (
        this.$http.options.root +
        "/transitToAdmin/" +
        window.localStorage.getItem("token")
      );
    },
    langIsZh() {
      return this.$store.state.currentLang === "zh";
    },
    customLogoColor() {
      return "#fff";
    },
  },
  data() {
    return {
      activity,
      changeHeader: false,
    };
  },
  created: function () {
    this.$store.commit("getToken");
  },
  mounted() {
    // mounted监听处理;
    window.addEventListener("scroll", this.scrollLoadMore);
  },
  methods: {
    signOut() {
      this.$store.dispatch("clearUserInfo");
      this.$router.replace("/");
    },
    scrollLoadMore() {
      let scrollTop = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollTop = document.body.scrollTop;
      }
      if (scrollTop > 0) {
        this.changeHeader = true;
      } else {
        this.changeHeader = false;
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../../assets/scss/variables";
@import "../../../assets/scss/mixins/button";
@import "../../../assets/scss/mixins/gradient";
@import "../../../assets/scss/activity";

body,
html {
  margin: 0;
  padding: 0;
}
* {
  padding: 0;
  margin: 0;
}

.navbar-nav .open .dropdown-menu {
  position: absolute;
}

.nav .open > a,
.nav > li > a:hover,
.nav > li > a:focus {
  background: transparent;
}
.home-header {
  width: 100%;
  // position: relative;
  height: 60px;

  overflow: hidden;
  .change-header {
    background-color: #fff;
  }
  .h5-header-box {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 3;
    .h5-header-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 24px;
      .logo-in-header {
        width: 126px;
        height: 100%;
        img {
          width: 100%;
          height: 28px;
          object-fit: contain;
        }
      }
      .header-nav {
        .fold-navigation {
          img {
            width: 24px;
            height: 20px;
            object-fit: contain;
          }
        }
      }
    }
  }
}

.menu-phone {
  height: 60px;
  line-height: 60px;
  position: relative;
  .fold-navigation {
    // margin: ((0.6rem - 0.18rem)/2) 0;
    cursor: pointer;
    span {
      display: block;
      height: 2px;
      width: 0.22rem;
      &:not(:last-child) {
        margin-bottom: 6px;
      }
    }
  }

  .dropdown-menu {
    position: absolute;
    top: 0.5rem;
    background: #fff;
    box-shadow: 0 6px 0.24rem 0 rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    padding: 0 0.1rem;
    text-align: center;
    li a {
      line-height: 0.6rem;
      font-size: 16px;
      color: #333333;
      letter-spacing: 0.38px;
      padding: 0;
    }
    li.border-bottom {
      border-bottom: 1px solid #efefef;
    }
  }
}

@mixin default-style() {
  background-color: white;
  .menu-phone span {
    background: #333;
  }
}

@mixin transparent-theme() {
  background: transparent;
  .menu-phone span {
    background: $header-transparent-theme-color;
  }
}

@mixin gradient-theme() {
  @include gradient-background(-135deg, #ec55ff 0%, #416cf8 100%);
  .menu-phone span {
    background: #fff;
  }
}

.home-header {
  @include default-style();
  &.transparent-theme {
    @include transparent-theme();
  }
  &.gradient-theme {
    @include gradient-theme();
  }
}
</style>



// WEBPACK FOOTER //
// MainHeaderPhone.vue?7d2fc5dc